var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('body',[_c('div',{ref:"target",staticClass:"gsap-container",staticStyle:{"width":"100vw","height":"100vh","z-index":"0","display":"flex"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }